export const CURRENCY_SYMBOL: Record<string, string> = {
  USD: '$', EUR: '€', GBP: '£', JPY: '¥', CNY: '¥', KRW: '₩',
  INR: '₹', THB: '฿', VND: '₫', IDR: 'Rp', PHP: '₱', MYR: 'RM',
  SGD: 'S$', HKD: 'HK$', TWD: 'NT$', AUD: 'A$', CAD: 'C$', NZD: 'NZ$',
  MXN: 'MX$', BRL: 'R$', ARS: '$', CLP: '$', COP: '$', PEN: 'S/',
  CHF: 'Fr', SEK: 'kr', NOK: 'kr', DKK: 'kr', PLN: 'zł', CZK: 'Kč',
  HUF: 'Ft', RON: 'lei', BGN: 'лв', RSD: 'дин', RUB: '₽', UAH: '₴',
  TRY: '₺', ILS: '₪', AED: 'د.إ', SAR: '﷼', QAR: '﷼', EGP: 'E£',
  ZAR: 'R', MAD: 'د.م.', GEL: '₾',
};

const NO_DECIMAL_CURRENCIES = new Set(['JPY', 'KRW', 'VND', 'IDR', 'CLP', 'HUF', 'TWD']);

export function formatPrice(value: number | null, currency: string | null): string {
  if (value === null) return '';
  const symbol = currency ? CURRENCY_SYMBOL[currency] ?? currency : '';
  const formatted = currency && NO_DECIMAL_CURRENCIES.has(currency)
    ? Math.round(value).toLocaleString('en-US')
    : value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return symbol ? `${symbol}${formatted}` : formatted;
}

export function priceForDisplay(args: { price: number | null; priceText: string | null; currency: string | null; preferOriginal: boolean }): string {
  const { price, priceText, currency, preferOriginal } = args;
  if (preferOriginal) {
    return priceText ?? formatPrice(price, currency);
  }
  if (price !== null) return formatPrice(price, currency);
  return priceText ?? '';
}
